import { useDispatch, useSelector } from "react-redux";
import HintArrow from "./HintArrow";
import ProjectCard from "./ProjectCard";
import { forwardRef, useEffect } from "react";
import { setActiveSection } from "../../store";
import SectionHeader from "./SectionHeader";

function WorksSection({ preventIntersectionObserver }, ref) {
  const { projectData } = useSelector((state) => state.app);
  const projectCardData = projectData.map((projectData, index) => (
    <ProjectCard
      projectData={projectData}
      projectIndex={index}
      key={index}
      className="mx-7"
    />
  ));
  const dispatch = useDispatch();

  /**
   * This is a callback to begin the observation of the div when the component first renders.
   */
  useEffect(() => {
    /**
     * An interaction observer object that allows us to monitor any interaction between the section's
     * div, and the viewport (visible area). It will make the section active when it intersects the
     * viewport.
     */
    const observer = new IntersectionObserver(
      (data) => {
        if (!preventIntersectionObserver.current && data[0].isIntersecting)
          dispatch(setActiveSection("works"));
      },
      {
        root: null,
        threshold: [0.55],
        rootMargin: "0px 5px 0px 0px",
      }
    );
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, dispatch, preventIntersectionObserver]);

  return (
    <div
      className="h-full w-max relative flex flex-row items-center pr-[200px]"
      ref={ref}
    >
      {projectCardData}
      <HintArrow className="absolute right-6 top-[45%]" />
      <SectionHeader text="My Projects" />
    </div>
  );
}

export default forwardRef(WorksSection);
